module.exports = __webpack_public_path__ + "static/media/concert8.abeba63e.jpg";